import CustomErrors from '@/components/error/customErrors/CustomErrors';
const error = () => <CustomErrors type="NOT_FOUND" data-sentry-element="CustomErrors" data-sentry-component="error" data-sentry-source-file="404.tsx" />;
export default error;